import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { OverlayService } from '@core/services';

import { environment } from '@environments/environment';

import { Subscription } from 'rxjs';

@Component({
  moduleId: module.id,
  selector: 'app-overlay',
  templateUrl: './overlay-message.component.html'
})
export class OverlayComponent implements OnDestroy {

  protected message: string;
  public messageEmitted: boolean;
  private presist: boolean;
  private redirectUrl: string;

  private subscriptions = new Subscription();

  constructor(
    private overlayService: OverlayService,
    private router: Router
  ) {
    this.presist = false;
    this.redirectUrl = '';
    this.reset();
    this.subscriptions.add(this.overlayService.overlayMessage.subscribe( ({message, redirect, persist}) => {
      this.displayOverlay(message, redirect, persist);
    }));
  }

  reset() {
    this.messageEmitted = false;
    this.message = '';
  }

  closeOverlay() {
    if (this.presist === true) {
      setTimeout( () => {
        this.reset();
        if (this.redirectUrl.length > 0) {
          this.router.navigate([this.redirectUrl]);
        }
      }, environment.OVERLAY_LENGTH);
    }

  }

  displayOverlay(value: string, redirect: string = '', persist: boolean = false) {
    this.presist = persist;
    this.redirectUrl = redirect.trim();
    if (value.trim().length > 0) {
      this.message = value;
      this.messageEmitted = true;
      // if the default of not being persist = false, then we need to set a timer to remove
      // the overlay. otherwise we will close the overlay based on a user click.
      if (this.presist === false) {
        setTimeout( () => {
          this.reset();
          if (this.redirectUrl.length > 0) {
            this.router.navigate([this.redirectUrl]);
          }
        }, environment.OVERLAY_LENGTH);
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
